import React, { useCallback, useEffect, useState } from "react";

import "../../../Assets/CSS/bulkorder.css";

import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import Button from "@mui/material/Button";
import axios from "axios";
import moment from "moment";
import { ClipLoader } from "react-spinners";
import { toast } from "react-toastify";
import { canApproveParent } from "../../../services/auth.service";

function OMSParentOrderList({ searchOrderId, parentOrderStatus }) {
  const [parentOrders, setParentOrders] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalResults, setTotalResults] = useState(0);
  const [itemPerPage, setItemPerPage] = useState(15);
  const [pageNumberLimit, setPageLimit] = useState(15);
  const [maxPageLimit, setMaxLimit] = useState(5);
  const [minPageLimit, setMinLimit] = useState(0);
  const [page, setPage] = useState(1);
  const [loading, setLoading] = useState(false);
  const [updating, setUpdating] = useState(false);

  const getParentOrders = useCallback(async () => {
    const url = `/api/parents/orders?page=${currentPage}&limit=${itemPerPage}&status=${parentOrderStatus}`;

    try {
      setLoading(true);
      setParentOrders([]);
      const { data } = await axios.get(url);
      if (data.status) {
        setTotalResults(data?.parent_orders?.count);
        setParentOrders(data?.parent_orders?.rows);
      } else {
        setTotalResults(0);
        setParentOrders([]);
      }
      setLoading(false);
    } catch (error) {
      setLoading(false);
      console.log(error);
    }
  }, [page, currentPage, searchOrderId, parentOrderStatus]);

  useEffect(() => {
    let token;
    if (searchOrderId) {
      clearTimeout(token);
      token = setTimeout(() => {
        getParentOrders();
      }, 1000);
    } else {
      getParentOrders();
    }
    return () => clearTimeout(token);
  }, [page, currentPage, searchOrderId, parentOrderStatus]);

  const pages = [];
  const handleClick1 = (event) => {
    setCurrentPage(Number(event.target.id));
    setPage(Number(event.target.id));
  };
  for (let i = 1; i <= Math.ceil(totalResults / itemPerPage); i++) {
    pages.push(i);
  }

  const handlePrevBtn = (e) => {
    if (currentPage === pages[0]) {
      return;
    }
    setPage(currentPage - 1);
    setCurrentPage(currentPage - 1);
    if ((currentPage - 1) % pageNumberLimit === 0) {
      setMaxLimit(maxPageLimit - pageNumberLimit);
      setMinLimit(minPageLimit - pageNumberLimit);
    }
  };
  const handleNextBtn = (e) => {
    if (currentPage === pages.length) {
      return;
    }
    setPage(currentPage + 1);
    setCurrentPage(currentPage + 1);
    if (currentPage + 1 > maxPageLimit) {
      setMaxLimit(maxPageLimit + pageNumberLimit);
      setMinLimit(minPageLimit + pageNumberLimit);
    }
  };

  const updateParentOrder = async (orderId, status) => {
    try {
      setUpdating(true);
      const response = await axios.patch("/api/parents/orders", {
        order_id: orderId,
        is_approved_status_special: status,
      });
      setUpdating(false);
      if (response.data.status) {
        getParentOrders();
        toast.success("Order lstatus changed successfully.");
      } else {
        toast.error("Error while updating order status.");
      }
    } catch {
      setUpdating(false);
      toast.error("Error while updating order status.");
    }
  };

  const renderPageNumbers = pages
    ? pages.map((number, index) => {
        if (number < maxPageLimit + 1 && number > minPageLimit) {
          return (
            <li
              key={index}
              className={
                currentPage === number ? "page-item active" : "page-item"
              }
              style={{ cursor: "pointer" }}
              onClick={(e) => handleClick1(e)}
            >
              <a
                href="#overview-page"
                className="page-link pb-2 ps-3 pt-2 pe-3"
                id={number}
              >
                {number}
              </a>
            </li>
          );
        } else return null;
      })
    : "";

  return (
    <div className=" ms-0 ps-0 m-2 pt-0">
      <>
        <div>
          <TableContainer component={Paper} className="overflow-x-scroll">
            <Table
              sx={{ minWidth: 650 }}
              size="small"
              aria-label="a dense table"
            >
              <TableHead className="shadow">
                <TableRow className="p-2 ">
                  <TableCell align="center" className="">
                    Ordered Date
                  </TableCell>
                  <TableCell align="center">Order ID</TableCell>
                  <TableCell align="center">Buyer Name</TableCell>
                  <TableCell align="center">Total Quantity</TableCell>
                  <TableCell align="center">Avail Quantity</TableCell>
                  <TableCell align="center">Order Status</TableCell>
                  {parentOrderStatus === "Pending" && canApproveParent() ? (
                    <TableCell align="center">Action</TableCell>
                  ) : null}
                </TableRow>
              </TableHead>
              {loading ? (
                <>
                  <TableCell></TableCell>
                  <TableCell></TableCell>
                  <TableCell></TableCell>
                  <TableCell>
                    <ClipLoader />
                  </TableCell>
                  <TableCell></TableCell>
                  <TableCell></TableCell>
                  {parentOrderStatus === "Pending" && canApproveParent() ? (
                    <TableCell></TableCell>
                  ) : null}
                </>
              ) : (
                <TableBody>
                  {parentOrders?.length === 0 ? (
                    <>
                      <TableCell></TableCell>
                      <TableCell></TableCell>
                      <TableCell></TableCell>
                      <TableCell align="center">No Data Found</TableCell>
                      <TableCell></TableCell>
                      <TableCell></TableCell>
                      {parentOrderStatus === "Pending" && canApproveParent() ? (
                        <TableCell></TableCell>
                      ) : null}
                    </>
                  ) : (
                    parentOrders?.map((row, index) => (
                      <TableRow
                        key={row.id}
                        sx={{
                          "&:last-child td, &:last-child th": { border: 0 },
                        }}
                      >
                        <TableCell align="center" style={{ width: "120px" }}>
                          {row?.ordered_date
                            ? moment(row?.ordered_date).format("DD-MM-YYYY")
                            : "NA"}
                        </TableCell>
                        <TableCell align="center">{row?.id}</TableCell>
                        <TableCell align="center">
                          {row?.user_id || "NA"}
                        </TableCell>
                        <TableCell align="center">
                          {isNaN(row?.total_quantity)
                            ? "NA"
                            : row?.total_quantity}
                        </TableCell>
                        <TableCell align="center">
                          {isNaN(row?.avail_quantity)
                            ? "NA"
                            : row?.avail_quantity}
                        </TableCell>
                        <TableCell align="center">
                          {row?.is_approved_status_special || "NA"}
                        </TableCell>
                        {parentOrderStatus === "Pending" &&
                        canApproveParent() ? (
                          <TableCell align="center">
                            <div className="flex flex-col gap-2 ">
                              <Button
                                variant="outlined"
                                disabled={updating}
                                onClick={() => {
                                  if (
                                    window.confirm(
                                      `You really want to approve parent order with ID: ${row.id}`
                                    )
                                  ) {
                                    updateParentOrder(row.id, "Approved");
                                  }
                                }}
                              >
                                Approve
                              </Button>
                              <Button
                                variant="outlined"
                                color="error"
                                disabled={updating}
                                onClick={() => {
                                  if (
                                    window.confirm(
                                      `You really want to reject parent order with ID: ${row.id}`
                                    )
                                  ) {
                                    updateParentOrder(row.id, "Rejected");
                                  }
                                }}
                              >
                                Reject
                              </Button>
                            </div>
                          </TableCell>
                        ) : null}
                      </TableRow>
                    ))
                  )}
                </TableBody>
              )}
            </Table>
            {parentOrders?.length !== 0 && (
              <div className="row mx-auto mt-3">
                <div className="col-sm-6 pt-2 d-flex justify-content-start">
                  Showing {15 * currentPage - (15 - 1)} to{" "}
                  {15 * currentPage > totalResults
                    ? totalResults
                    : 15 * currentPage}{" "}
                  entries of {totalResults ? totalResults : ""}
                </div>
                <div className="col-sm-6 d-flex justify-content-end">
                  <ul className="pagination">
                    <li className="page-item pt-1 pl-2 pr-2 border">
                      <a
                        href="#overview-page"
                        className={
                          currentPage !== pages[0] ? "show" : "hideBtn"
                        }
                        onClick={(e) => handlePrevBtn(e)}
                      >
                        Prev
                      </a>
                    </li>
                    {renderPageNumbers}
                    <li className="page-item pt-1 pl-2 pr-2 border border-left-0">
                      <a
                        href="#overview-page"
                        className={
                          currentPage !== pages.length ? "show" : "hideBtn"
                        }
                        onClick={(e) => handleNextBtn(e)}
                      >
                        Next
                      </a>
                    </li>
                  </ul>
                </div>
              </div>
            )}
          </TableContainer>
        </div>
      </>
    </div>
  );
}

export default OMSParentOrderList;
